import { __rest, __assign } from 'tslib';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { useTheme } from '../hooks/useTheme.js';
import { CaretDownSolidIcon } from '@compono/ui-icons';
import { Button } from '../Button/Button.js';
import '../Button/ButtonBase/index.js';
import '../Button/ButtonBody/index.js';
import { Box } from '../Box/index.js';

var TableSortButton = forwardRef(function TableSortButton(_a, ref) {
    var _b = _a.size, size = _b === void 0 ? "inherit" : _b, _c = _a.tone, tone = _c === void 0 ? "inherit" : _c, _d = _a.look, look = _d === void 0 ? "naked" : _d, order = _a.order, sx = _a.sx, children = _a.children, props = __rest(_a, ["size", "tone", "look", "order", "sx", "children"]);
    var mergeStyles = useTheme().mergeStyles;
    var baseStyle = mergeStyles([
        {
            display: "inline-flex",
            width: ["auto"],
            height: "auto",
            textAlign: "left",
            whiteSpace: "unset",
            alignItems: "flex-end",
            flexWrap: "nowrap",
            transition: "color ease-in-out",
            transitionDuration: 5,
            gap: 1,
            "[data-table-sort-button-icon]": {
                display: "inline-flex",
                alignItems: "center",
                height: "18px",
                fontSize: "16px",
                transition: "transform ease-in-out",
                transitionDuration: 5,
                transform: "scaleY(0)",
            },
            '&[data-order="asc"]': {
                color: "primary.100",
                "[data-table-sort-button-icon]": {
                    transform: "scaleY(-1)",
                },
            },
            '&[data-order="desc"]': {
                color: "primary.100",
                "[data-table-sort-button-icon]": {
                    transform: "scaleY(1)",
                },
            },
        },
        sx,
    ]);
    return (jsxs(Button, __assign({ ref: ref, title: "Sort column" }, __assign({ size: size, look: look, tone: tone, sx: baseStyle }, props), { "data-order": order }, { children: [jsx(Box, __assign({ component: "span", "data-table-sort-button-label": true }, { children: children })), order && (jsx(Box, __assign({ component: "span", "data-table-sort-button-icon": true }, { children: jsx(CaretDownSolidIcon, { title: "Sorted ".concat(order === "asc" ? "ascending" : "descending") }) })))] })));
});

export { TableSortButton };
//# sourceMappingURL=TableSortButton.js.map
